import styled, { css, theme } from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

const DefaultButton = styled.button`
  width: 100%;
  font-size: ${rem(16)};
  line-height: ${rem(16)};
  padding: ${rem(14)} ${rem(32)};
  font-weight: 500;
  border-radius: ${rem(6)};
  border: ${rem(1)} solid ${theme('colors.primary')};

  &:hover,
  &:focus {
    border-color: ${theme('colors.blue')};
    background-color: ${theme('colors.blue')};
  }
`

const OutlineButton2 = styled(DefaultButton)`
  color: ${theme('colors.primary')};

  &:hover,
  &:focus {
    color: ${theme('colors.white')};
  }
`
const SolidButton2 = styled(DefaultButton)`
  color: ${theme('colors.white')};
  background-color: ${theme('colors.primary')};
`

export const Button = ({ children, outline, ...props }) =>
  outline ? (
    <OutlineButton2 {...props}>{children}</OutlineButton2>
  ) : (
    <SolidButton2 {...props}>{children}</SolidButton2>
  )

Button.defaultProps = {
  outline: false,
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  outline: PropTypes.bool,
}

const ButtonCss = css`
  text-align: center;
  width: ${(p) => p.fullWidth && '100%'};
  font-size: ${(p) => rem(p.theme.buttons.fontSize[p.size])};
  font-weight: ${(p) => p.theme.buttons.fontWeight};
  border-radius: ${(p) => rem(p.theme.buttons.borderRadius)};
  line-height: ${(p) => rem(p.theme.buttons.lineHeight)};
  padding: ${(p) => p.theme.buttons.padding[p.size]};
  letter-spacing: ${(p) => rem(p.theme.buttons.letterSpacing)};
  text-transform: ${(p) => p.theme.buttons.textTransform};
`

export const SolidButtonCss = css`
  ${ButtonCss}
  color: ${(p) => p.theme.buttons[p.buttonType].color};
  background-color: ${(p) => p.theme.buttons[p.buttonType].background};

  :hover,
  :focus,
  :active {
    color: ${(p) => p.theme.buttons[p.buttonType].activeColor};
    background-color: ${(p) => p.theme.buttons[p.buttonType].activeBackground};
  }
  :disabled {
    color: ${(p) => p.theme.buttons.disabled.color};
    background-color: ${(p) => p.theme.buttons.disabled.background};
    cursor: not-allowed;
  }
`

export const OutlineButtonCss = css`
  ${ButtonCss}
  color: ${(p) => p.theme.buttons.outlined.background};
  background-color: transparent;
  border: ${rem(1)} solid ${(p) => p.theme.buttons.outlined.background};

  :hover,
  :focus,
  :active {
    color: ${(p) => p.theme.buttons.outlined.activeBackground};
    border-color: ${(p) => p.theme.buttons.outlined.activeBackground};
  }

  :disabled {
    color: ${(p) => p.theme.buttons.disabled.background};
    border-color: ${(p) => p.theme.buttons.disabled.background};
    cursor: not-allowed;
  }
`

export const SolidButton = styled.button`
  ${SolidButtonCss}
`

export const OutlineButton = styled.button`
  ${OutlineButtonCss}
`

SolidButton.defaultProps = {
  buttonType: 'primary',
  size: 'default',
  fullWidth: false,
}

SolidButton.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  fullWidth: PropTypes.bool,
}

OutlineButton.defaultProps = {
  buttonType: 'primary',
  size: 'default',
  fullWidth: false,
}

OutlineButton.propTypes = {
  buttonType: PropTypes.oneOf(['primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'default', 'large']),
  fullWidth: PropTypes.bool,
}
